// Ported from twifi-theme-html/src/scripts/helpers/account-type-toggle.js
//
// Drives the checkout's "I'm New Here" / "I Have An Account" switch: the checked radio marks
// its own option active and reveals the matching [data-account-panel] sibling. Markup comes
// from templates/parts/account-type-toggle.twig plus the two panels in
// woocommerce/checkout/form-checkout.php; the toggle only renders for logged-out users.
function initAccountToggle(root) {
    const options = Array.from(root.querySelectorAll('.account-type__option'));
    const panels = root.querySelectorAll('[data-account-panel]');

    function sync() {
        options.forEach((option) => {
            const input = option.querySelector('.account-type__input');

            option.classList.toggle('account-type__option--active', input.checked);

            if (input.checked) {
                panels.forEach((panel) => {
                    panel.hidden = panel.dataset.accountPanel !== input.value;
                });
            }
        });
    }

    options.forEach((option) => {
        option.querySelector('.account-type__input').addEventListener('change', sync);
    });

    sync();
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-account-toggle]').forEach(initAccountToggle);
});
